module.exports = __webpack_public_path__ + "img/9e899d7ce675d01c87931ce9c12caf6b.04ac5d22.png";